import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import useNetworkId from '../../../hooks/useNetworkId'
import { selectDesiredNetworkId } from '../../../modules/web3/selectors'
import { ThemedButton } from '../../ThemedButton'
import { Strong } from '../Typeography'

function SwitchToBaseButton({
  $styleType = 'surface-chip',
  w,
}: {
  $styleType?: string
  w?: string
}) {
  const { changeNetwork } = useNetworkId()

  const desiredNetworkId = useSelector(selectDesiredNetworkId)

  const switchToDesiredNetwork = useCallback(() => {
    changeNetwork(desiredNetworkId)
  }, [changeNetwork, desiredNetworkId])

  return (
    <ThemedButton
      onClick={switchToDesiredNetwork}
      $styleType={$styleType}
      type="button"
      w={w}
    >
      <img src="/img/icons/chains/color-circle/base.svg" alt="switch to base" />
      <Strong>Switch to BASE</Strong>
    </ThemedButton>
  )
}

export default SwitchToBaseButton
